'use client';

import {cn} from '@purpose/ui/lib/utils';
import {colors} from '@purpose/ui/styles/theme/colors';
import {CSSProperties} from 'react';

type TagProps = {
  title: string;
  color?: 'category' | string;
  className?: string;
  style?: CSSProperties;
};

const Tag = ({title, color, className, style}: TagProps) => {
  const baseStyles =
    'inline-flex items-center rounded-[5px] h-7 px-2 text-[12px] font-sans';

  const colorStyles = (() => {
    if (!color) return '';

    if (color === 'category') {
      return 'bg-primary-0 text-primary-80';
    }

    return `bg-[${colors.accent[`${color}_medium`]}] text-[${colors?.[color][50]}]`;
  })();

  return (
    <span className={cn(baseStyles, colorStyles, className)} style={style}>
      {title}
    </span>
  );
};

export default Tag;
